import FadeInSection from '../../../components/feature/FadeInSection';

const LINE_URL = 'https://lin.ee/PNbhQI0';

export default function PartnerCTASection() {
  return (
    <section
      className="section-padding"
      style={{ background: 'linear-gradient(135deg, #e8934e 0%, #d4a574 100%)' }}
    >
      <div className="content-width">
        <FadeInSection className="text-center mb-12">
          <h2 className="text-white mb-4">まずは無料相談へ</h2>
          <p className="text-white/90" style={{ fontSize: '18px' }}>
            費用は一切かかりません。あなたのペースでお気軽にどうぞ。
          </p>
        </FadeInSection>

        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
          <a
            href="tel:03-4500-8399"
            className="flex items-center gap-3 px-10 py-5 rounded-xl font-bold text-[#8b4513] hover:scale-[1.02] transition-transform w-full sm:w-auto justify-center whitespace-nowrap"
            style={{ background: 'rgba(255,255,255,0.95)', fontSize: '18px', minWidth: '240px' }}
          >
            <span className="flex items-center justify-center w-6 h-6">
              <i className="ri-phone-line text-xl"></i>
            </span>
            03-4500-8399
          </a>

          <a
            href={LINE_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-3 px-10 py-5 rounded-xl font-bold text-white hover:scale-[1.02] transition-transform w-full sm:w-auto justify-center whitespace-nowrap"
            style={{ background: '#06C755', fontSize: '18px', minWidth: '240px' }}
          >
            <span className="flex items-center justify-center w-6 h-6">
              <i className="ri-line-fill text-xl"></i>
            </span>
            LINEで無料相談
          </a>

          <a
            href="/contact"
            className="flex items-center gap-3 px-10 py-5 rounded-xl font-bold hover:scale-[1.02] transition-transform w-full sm:w-auto justify-center whitespace-nowrap"
            style={{
              background: 'transparent',
              border: '2px solid rgba(255,255,255,0.9)',
              color: '#fff',
              fontSize: '18px',
              minWidth: '240px',
            }}
          >
            <span className="flex items-center justify-center w-6 h-6">
              <i className="ri-mail-line text-xl"></i>
            </span>
            フォームで相談
          </a>
        </div>

        <FadeInSection className="text-center mt-10">
          <p className="text-white/80" style={{ fontSize: '15px' }}>
            受付時間：10:00〜18:00　電話番号：03-4500-8399
          </p>
        </FadeInSection>
      </div>
    </section>
  );
}
